import React from "react";
import PropTypes from "prop-types";
import "./Dialog.css";

const ReportBugLink = (props) => (
	<a
		href="https://chat.whatsapp.com/Cnov6rFZDZ55op5e7u8UHN"
		target="_blank"
		rel="noopener noreferrer"
	>
		{props.children}
	</a>
);
ReportBugLink.propTypes = {
	children: PropTypes.node.isRequired,
};

export default function Dialog({
	message,
	error,
	// isError, 
	requestBugReport,
	close,
	extraButtons,
	buttons,
	// message *content* max 40em, bring in line with `.Dialog details`
	// look at some error messages to see if any are made uglier by the automatic line breaks
	maxWidth = "50em",
}) {
	const stackTraceText =
		error &&
		error.stack &&
		(error.stack.indexOf(error.toString()) === 0
			? error.stack.slice(error.toString().length).trimEnd() 
			: `\n${error.stack.trim()}`.replace(/\n/g, "\n    ")); 
	const errorText =
		error &&
		(stackTraceText
			? `${error.toString()}\n\nStack trace:${stackTraceText}`
			: error.toString());

	return (
		<div className="Dialog">
			<div className="Dialog-box" style={{ maxWidth }}>
				{message || error.message}
				{error && (
					<details>
						<summary>Details</summary>
						<div className="actual-details">
							<pre>{errorText}</pre>
						</div>
					</details>
				)}
				{requestBugReport && (
					<div>
						You should <ReportBugLink>report this bug</ReportBugLink>.
					</div>
				)}
				<div className="Dialog-buttons">
					{buttons || <button onClick={close}>Close</button>}
					{extraButtons}
				</div>
			</div>
		</div>
	);
}

Dialog.propTypes = {
	message: PropTypes.node.isRequired,
	error: PropTypes.object,
	isError: PropTypes.bool,
	requestBugReport: PropTypes.bool,
	close: PropTypes.func,
	extraButtons: PropTypes.node,
	buttons: PropTypes.node,
	maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
